import Pdf from '@/components/pdf/index.vue'
import PdfDownload from '@/components/pdf/pdfDownload.vue';
import WikiCapture from '@/components/pdf/capture.vue';

const PDFDowloadRoute = {
  path: "/pdfdownload",
  component: Pdf,
  meta: { requireAuth: true },
  children: [
    {
      path:'/',
      name:'PdfDownload',
      component: PdfDownload,
    },
    {
      path:'/pdfdownload/wikiCapture',
      name:'WikiCapture',
      component: WikiCapture, 
    },
  ]
}

export default PDFDowloadRoute ;